"use client";

import * as React from "react";
import { Input } from "@shared/src/components/ui/input";
import { Search, X } from "lucide-react";
import { cn } from "@shared/src/utils/cn";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  onClear?: () => void;
  className?: string;
  containerClassName?: string;
  placeholder?: string;
}

export function SearchInput({
  value,
  onChange,
  onClear,
  className,
  containerClassName,
  placeholder,
  ...props
}: SearchInputProps) {
  return (
    <div className={cn("relative flex items-center", containerClassName)}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-text-tertiary pointer-events-none" />
      <Input
        type="text"
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        placeholder={placeholder}
        className={cn(
          "w-full pl-10 pr-8 py-4 bg-transparent !border-2 !border-border-secondary h-[48px] rounded-2xl text-text-primary placeholder:text-text-tertiary max-sm:placeholder:text-small max-sm:text-small focus:outline-none focus-visible:ring-0",
          className,
        )}
        {...props}
      />
      {value && onClear && (
        <button
          type="button"
          onClick={onClear}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-text-tertiary hover:text-text-primary"
        >
          <X className="h-5 w-5" />
        </button>
      )}
    </div>
  );
}
